import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { CRITERIA_SELECTORS } from 'Views/booking/constants';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  className?: string;
  template: string;
  values: {
    arrivalDate: string;
    departureDate: string;
  };
};
export const DateSummary = ({ className, template, values }: Props) => (
  <p
    className={classnames('flex items-center gap-10 text-14', className)}
    data-testid={CRITERIA_SELECTORS.DEPARTURE}
  >
    <Icon className="shrink-0 text-sienna" hasRtl name={ICONS.DATE} width="1.875rem" />
    <TemplateString
      dataTestId="DateSummary"
      template={template}
      values={values}
      valuesClassName={{
        arrivalDate: 'font-bold text-sienna',
        departureDate: 'font-bold text-sienna',
      }}
    />
  </p>
);
